export const SELECT_DAY = 'SELECT_DAY';
